module.exports = __webpack_public_path__ + "img/selected1-min.2a8374e1.png";